module.exports = __webpack_public_path__ + "assets/images/project/people/baby-chart1.png?v=7041c119";